// extracted by mini-css-extract-plugin
export default {"wrapper":"PerformaKerja_wrapper__kkyWH","title":"PerformaKerja_title__x1h55","subTitle":"PerformaKerja_subTitle__fqcba","button":"PerformaKerja_button__dqSGK"};